var _isLoaded,
    _searchQueryString,
    searchQueryString_get,
    _loadProducts,
    loadProducts_fn,
    __accessCheck = (e, t, i) => {
        if (!t.has(e)) throw TypeError("Cannot " + i);
    },
    __privateGet = (e, t, i) => (__accessCheck(e, t, "read from private field"), i ? i.call(e) : t.get(e)),
    __privateAdd = (e, t, i) => {
        if (t.has(e)) throw TypeError("Cannot add the same private member more than once");
        t instanceof WeakSet ? t.add(e) : t.set(e, i);
    },
    __privateSet = (e, t, i, s) => (__accessCheck(e, t, "write to private field"), s ? s.call(e, i) : t.set(e, i), i),
    __privateMethod = (e, t, i) => (__accessCheck(e, t, "access private method"), i);
import { timeline as e } from "//one2threejewelry.com/cdn/shop/t/46/assets/vendor.min.js?v=136053555471622566971792588923";
import { EffectCarousel as t } from "//one2threejewelry.com/cdn/shop/t/46/assets/theme.js?v=54322583012850650201792588923";
var AnnouncementBar = class extends t {
    _transitionTo(t, i) {
        e([
            [t, { transform: ["translateY(0)", "translateY(-5px)"], opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 0.2 }],
            [i, { transform: ["translateY(5px)", "translateY(0)"], opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.2 }],
        ]);
    }
};
window.customElements.get("announcement-bar") || window.customElements.define("announcement-bar", AnnouncementBar);
var SplitCursor = class extends HTMLElement {
    connectedCallback() {
        (this._parentSection = this.closest(".shopify-section")),
            (this._dragging = !1),
            (this._offsetX = this._currentX = 0),
            this._parentSection.addEventListener("pointerdown", this._onPointerDown.bind(this)),
            this._parentSection.addEventListener("pointermove", this._onPointerMove.bind(this)),
            this._parentSection.addEventListener("pointerup", this._onPointerUp.bind(this)),
            window.addEventListener("resize", this._recalculateOffset.bind(this));
    }
    get minOffset() {
        return -this.offsetLeft - ("rtl" === document.dir ? this.clientWidth : 0);
    }
    get maxOffset() {
        return this.offsetParent.clientWidth + this.minOffset;
    }
    _onPointerDown(e) {
        (e.target === this || this.contains(e.target)) && ((this._initialX = e.clientX - this._offsetX), (this._dragging = !0));
    }
    _onPointerMove(e) {
        this._dragging &&
            ((this._currentX = Math.min(Math.max(e.clientX - this._initialX, this.minOffset), this.maxOffset)),
            (this._offsetX = this._currentX),
            this._parentSection.style.setProperty("--clip-path-offset", `${this._currentX.toFixed(1)}px`));
    }
    _onPointerUp() {
        this._dragging = !1;
    }
    _recalculateOffset() {
        this._parentSection.style.setProperty("--clip-path-offset", `${Math.min(Math.max(this.minOffset, this._currentX.toFixed(1)), this.maxOffset)}px`);
    }
};
window.customElements.get("split-cursor") || window.customElements.define("split-cursor", SplitCursor);
import { timeline as i, inView as s } from "//one2threejewelry.com/cdn/shop/t/46/assets/vendor.min.js?v=136053555471622566971792588923";
var CollectionList = class extends HTMLElement {
    connectedCallback() {
        window.matchMedia("(prefers-reduced-motion: no-preference)").matches && s(this, this._reveal.bind(this), { margin: "-100px" });
    }
    _reveal() {
        let e = Array.from(this.querySelectorAll("[reveal-js]"));
        i([
            [e, { opacity: 1 }, { duration: 0 }],
            [e.map((e) => e.querySelector("img, svg")), { opacity: [0, 1], transform: ["scale(1.03)", "auto"] }, { duration: 0.2 }],
            [e.map((e) => e.querySelector(".collection-card__content-wrapper")), { opacity: [0, 1] }, { duration: 0.2 }],
        ]);
    }
};
window.customElements.get("collection-list") || window.customElements.define("collection-list", CollectionList);
import { Delegate as r } from "//one2threejewelry.com/cdn/shop/t/46/assets/vendor.min.js?v=136053555471622566971792588923";
var AccountLogin = class extends HTMLElement {
    connectedCallback() {
        (this.recoverForm = this.querySelector("#recover")),
            (this.loginForm = this.querySelector("#login")),
            "#recover" === window.location.hash && this._switchForms(),
            new r(this).on("click", '[href="#recover"], [href="#login"]', this._switchForms.bind(this));
    }
    _switchForms(e) {
        e && e.preventDefault(), (this.recoverForm.hidden = !this.recoverForm.hidden), (this.loginForm.hidden = !this.loginForm.hidden);
    }
};
window.customElements.get("account-login") || window.customElements.define("account-login", AccountLogin);
import { animate as a, timeline as n, stagger as o, Delegate as l } from "//one2threejewelry.com/cdn/shop/t/46/assets/vendor.min.js?v=136053555471622566971792588923";
import { AnimatedDetails as c, EffectCarousel as d, Drawer as h, throttle as u } from "//one2threejewelry.com/cdn/shop/t/46/assets/theme.js?v=54322583012850650201792588923";
var reduceMenuAnimation = JSON.parse("true"),
    StoreHeader = class extends HTMLElement {
        connectedCallback() {
            this.hasAttribute("hide-on-scroll") &&
                window.matchMedia("(prefers-reduced-motion: no-preference)").matches &&
                ((this._lastScrollTop = 0), (this._accumulatedScroll = 0), (this._isVisible = !0), (this._hasSwitchedToSticky = !1), window.addEventListener("scroll", u(this._onScroll.bind(this)))),
                this.addEventListener("toggle", this._checkTransparency.bind(this), { capture: !0 }),
                this.hasAttribute("sticky") &&
                    (this._setupTransparentHeader(),
                    Shopify.designMode &&
                        (document.addEventListener("shopify:section:load", this._setupTransparentHeader.bind(this)),
                        document.addEventListener("shopify:section:unload", this._setupTransparentHeader.bind(this)),
                        document.addEventListener("shopify:section:reorder", this._setupTransparentHeader.bind(this))));
        }
        hide() {
            this._isVisible && (a(this, { transform: ["translateY(0)", "translateY(-100%)"] }, { duration: 0.2, easing: "ease" }), (this._isVisible = !1));
        }
        show() {
            this._isVisible || (a(this, { transform: ["translateY(-100%)", "translateY(0)"] }, { duration: 0.2, easing: "ease" }), (this._accumulatedScroll = 0), (this._isVisible = !0));
        }
        _onScroll() {
            !(window.scrollY < 0) &&
                ((this._accumulatedScroll = Math.max(0, this._accumulatedScroll + (window.scrollY - this._lastScrollTop))),
                window.scrollY < this._lastScrollTop ? this.show() : this._accumulatedScroll > parseInt(this.getAttribute("hide-on-scroll")) && this.hide(),
                (this._lastScrollTop = window.scrollY));
        }
        _checkTransparency() {
            let e = !1;
            CSS.supports("selector(:has(> *))") && this.hasAttribute("sticky") && !this.hasAttribute("hide-on-scroll") && this.hasAttribute("allow-transparency")
                ? this.querySelectorAll("[open]").length > 0
                    ? this.classList.add("is-filled")
                    : window.scrollY >= 500 && !this._hasSwitchedToSticky
                    ? ((this._hasSwitchedToSticky = !0), this.classList.add("is-filled"), a(this, { transform: ["translateY(-100%)", "translateY(0)"] }, { duration: 0.15, easing: "ease" }))
                    : window.scrollY < 500 &&
                      (this._hasSwitchedToSticky
                          ? ((this._hasSwitchedToSticky = !1),
                            a(this, { transform: ["translateY(0)", "translateY(-100%)"] }, { duration: 0.15, easing: "ease" }).finished.then(() => {
                                (this.style.transform = null), this.classList.remove("is-filled");
                            }))
                          : 0 === this.getAnimations().length && this.classList.remove("is-filled"))
                : ((e = window.scrollY > 20), this.classList.toggle("is-filled", !this.hasAttribute("allow-transparency") || this.querySelectorAll("[open]").length > 0 || e));
        }
        _setupTransparentHeader() {
            document.querySelector(".shopify-section:first-child [allow-transparent-header]")
                ? (this.setAttribute("allow-transparency", ""),
                  window.addEventListener("scroll", u(this._checkTransparency.bind(this))),
                  this.addEventListener("mouseenter", this._checkTransparency.bind(this)),
                  this.addEventListener("mouseleave", this._checkTransparency.bind(this)),
                  this._checkTransparency())
                : this.removeAttribute("allow-transparency");
        }
    },
    DropdownDisclosure = class extends c {
        constructor() {
            super(),
                (this._detectClickOutsideListener = this._detectClickOutside.bind(this)),
                (this._detectEscKeyboardListener = this._detectEscKeyboard.bind(this)),
                (this._detectFocusOutListener = this._detectFocusOut.bind(this)),
                (this._detectHoverListener = this._detectHover.bind(this)),
                (this._hoverTimer = null),
                this.addEventListener("mouseover", this._detectHoverListener.bind(this)),
                this.addEventListener("mouseout", this._detectHoverListener.bind(this));
        }
        get trigger() {
            return window.matchMedia("screen and (pointer: fine)").matches ? this.getAttribute("trigger") : "click";
        }
        get mouseOverDelayTolerance() {
            return 250;
        }
        _onSummaryClicked(e) {
            "hover" === this.trigger ? (e.preventDefault(), e.currentTarget.hasAttribute("data-url") && (window.location.href = e.currentTarget.getAttribute("data-url"))) : super._onSummaryClicked(e);
        }
        async _transition(e) {
            if (e) {
                this.setAttribute("open", ""),
                    document.addEventListener("click", this._detectClickOutsideListener),
                    document.addEventListener("keydown", this._detectEscKeyboardListener),
                    document.addEventListener("focusout", this._detectFocusOutListener);
                let t = Array.from(this.closest("ul").querySelectorAll("[open]")).filter((e) => e !== this);
                t.forEach((e) => (e.open = !1)), await this._transitionIn(t.length > 0);
            } else
                document.removeEventListener("click", this._detectClickOutsideListener),
                    document.removeEventListener("keydown", this._detectEscKeyboardListener),
                    document.removeEventListener("focusout", this._detectFocusOutListener),
                    await this._transitionOut(),
                    this.removeAttribute("open");
        }
        _transitionIn(e = !1) {
            let t = [[this.contentElement, { opacity: 1 }, { duration: 0.2 }]];
            return (
                window.matchMedia("(prefers-reduced-motion: no-preference)").matches &&
                    !reduceMenuAnimation &&
                    t.push([this.contentElement.querySelectorAll(":scope > ul > li"), { opacity: [0, 1], transform: ["translateY(-10px)", "translateY(0)"] }, { delay: o(0.025), at: "-0.1", duration: 0.2 }]),
                n(t, { delay: e > 0 ? 0.1 : 0 }).finished
            );
        }
        _transitionOut() {
            return n([[this.contentElement, { opacity: 0 }, { duration: 0.2 }]]).finished;
        }
        _detectClickOutside(e) {
            "click" === this.trigger && (this.contains(e.target) || e.target.closest("details") instanceof DropdownDisclosure || (this.open = !1));
        }
        _detectHover(e) {
            "hover" === this.trigger && ("mouseover" === e.type ? ((this.open = !0), clearTimeout(this._hoverTimer)) : (this._hoverTimer = setTimeout(() => (this.open = !1), this.mouseOverDelayTolerance)));
        }
        _detectEscKeyboard(e) {
            if ("Escape" === e.code) {
                let t = e.target.closest("details[open]");
                t && (t.open = !1);
            }
        }
        _detectFocusOut(e) {
            e.relatedTarget && !this.contains(e.relatedTarget) && (this.open = !1);
        }
    },
    MegaMenuDisclosure = class extends DropdownDisclosure {
        constructor() {
            super(), this.addEventListener("pointerover", this._preloadImages.bind(this));
        }
        get mouseOverDelayTolerance() {
            return 500;
        }
        _transitionIn(e) {
            let t = [[this.contentElement, { opacity: 1 }, { duration: 0.2 }], "mega-menu"],
                i = e ? 0.1 : 0;
            return (
                window.matchMedia("(prefers-reduced-motion: no-preference)").matches &&
                    !reduceMenuAnimation &&
                    (this.contentElement.querySelectorAll(".mega-menu__promo").forEach((e) => {
                        t.push([e, { opacity: [0, 1] }, { duration: 0.25, delay: i, at: "mega-menu" }], "mega-menu-promo");
                    }),
                    this.contentElement.querySelectorAll(".mega-menu__nav > li").forEach((e) => {
                        t.push([
                            e.querySelectorAll(":scope > :first-child, :scope li"),
                            { opacity: [0, 1], transform: ["translateY(-10px)", "translateY(0)"] },
                            { easing: "ease", delay: o(0.025, { start: i }), at: "mega-menu", duration: 0.2 },
                        ]);
                    })),
                n(t).finished
            );
        }
        _preloadImages() {
            Array.from(this.querySelectorAll('img[loading="lazy"]')).forEach((e) => e.setAttribute("loading", "eager"));
        }
    },
    MegaMenuPromoCarousel = class extends d {
        connectedCallback() {
            super.connectedCallback(), this.nextElementSibling && this.addEventListener("carousel:select", (e) => this._updateControlsColor(e.detail.slide)), this._updateControlsColor(this.items[this.selectedIndex]);
        }
        _updateControlsColor(e) {
            let t = e.classList.contains("content-over-media") ? e : e.firstElementChild;
            this.nextElementSibling.style.setProperty("--text-color", t.style.getPropertyValue("--text-color"));
        }
    },
    NavigationDrawer = class extends h {
        constructor() {
            super();
            let e = new l(this);
            e.on("click", "button[data-panel]", this._onPanelButtonClick.bind(this)),
                (this._isTransitioning = !1),
                this.addEventListener("dialog:after-hide", () => {
                    this.reinitializeDrawer();
                });
        }
        get openFrom() {
            return window.matchMedia("(max-width: 699px)").matches ? this.getAttribute("mobile-opening") : super.openFrom;
        }
        switchToPanel(e, t = null) {
            let i = this.querySelectorAll(".panel"),
                s,
                r,
                a = null !== t ? i[parseInt(e) - 1] : i[parseInt(e) + 1],
                o = i[e],
                l = o.querySelectorAll(".panel__wrapper"),
                c = [];
            "rtl" === document.dir
                ? ((s = null !== t ? ["translateX(0%)", "translateX(100%)"] : ["translateX(0%)", "translateX(-100%)"]), (r = null !== t ? ["translateX(-100%)", "translateX(0%)"] : ["translateX(100%)", "translateX(0%)"]))
                : ((s = null !== t ? ["translateX(0%)", "translateX(-100%)"] : ["translateX(0%)", "translateX(100%)"]), (r = null !== t ? ["translateX(100%)", "translateX(0%)"] : ["translateX(-100%)", "translateX(0%)"])),
                c.push([a, { transform: s, opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 0.3, opacity: { at: "+0.3" }, transform: { at: "+0.3" } }], "panelHidden", [
                    o,
                    { opacity: [0, 1], visibility: ["hidden", "visible"], transform: r },
                    { at: "<", transform: { duration: 0.3 } },
                ]),
                null !== t && c.push(this.switchLinkList(l, t)),
                n(c);
        }
        showPanel(e, t = null) {
            let i = this.querySelectorAll(".panel"),
                s = [],
                r = i[e],
                a = r.querySelectorAll(".panel__wrapper");
            r.hasAttribute("open") ||
                this._isTransitioning ||
                ((this._isTransitioning = !0),
                s.push(
                    [this, { width: [this.offsetWidth + "px", (this.offsetWidth - parseInt(window.getComputedStyle(this).getPropertyValue("padding"))) * 2 + "px"] }, { duration: 0.2 }],
                    [r, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { at: "<" }]
                ),
                s.push(this.switchLinkList(a, t))),
                this.previousLinkIndex && this.previousLinkIndex !== t && s.push([a[this.previousLinkIndex], { opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 0.2 }]),
                n(s).finished.then(() => {
                    this.previousLinkIndex && this.previousLinkIndex !== t && a[this.previousLinkIndex].removeAttribute("style"),
                        r.hasAttribute("open") && this.previousLinkIndex !== t && n([this.switchLinkList(a, t)]),
                        (this.previousLinkIndex = t),
                        r.setAttribute("open", ""),
                        (this._isTransitioning = !1);
                });
        }
        switchLinkList(e, t) {
            return (
                Array.from(e).forEach((e) => {
                    e.setAttribute("hidden", "");
                }),
                e[t].removeAttribute("hidden"),
                [e[t].querySelectorAll("li"), { opacity: [0, 1], visibility: ["hidden", "visible"], transform: ["translateY(-10px)", "translateY(0)"] }, { easing: "ease", duration: 0.2, at: "-0.15", delay: o(0.025, { start: 0.1 }) }]
            );
        }
        reinitializeDrawer() {
            if (this.hasAttribute("mega-menu") && window.matchMedia("(min-width:1150px)").matches) this.style.removeProperty("width"), this.setExpanded();
            else {
                let e = this.querySelector(".panel:first-child");
                (e.style.opacity = "1"), (e.style.visibility = "visible"), (e.style.transform = "translateX(0%)");
            }
            Array.from(this.querySelectorAll(".panel:not(:first-child)")).forEach((e) => {
                this.hasAttribute("mega-menu") && e.removeAttribute("open"), (e.style.opacity = "0"), (e.style.visibility = "hidden"), Array.from(e.querySelectorAll(".panel__wrapper")).forEach((e) => e.setAttribute("hidden", ""));
            });
        }
        setExpanded(e) {
            Array.from(this.querySelectorAll("button[data-panel]")).forEach((e) => {
                e.setAttribute("aria-expanded", "false");
            }),
                e && e.setAttribute("aria-expanded", "true");
        }
        _onPanelButtonClick(e, t) {
            this.hasAttribute("mega-menu") && window.matchMedia("(min-width:1150px)").matches
                ? (this.setExpanded(t), this.showPanel(...t.getAttribute("data-panel").split("-")))
                : this.switchToPanel(...t.getAttribute("data-panel").split("-"));
        }
    };
window.customElements.get("store-header") || window.customElements.define("store-header", StoreHeader),
    window.customElements.get("dropdown-disclosure") || window.customElements.define("dropdown-disclosure", DropdownDisclosure, { extends: "details" }),
    window.customElements.get("mega-menu-disclosure") || window.customElements.define("mega-menu-disclosure", MegaMenuDisclosure, { extends: "details" }),
    window.customElements.get("mega-menu-promo-carousel") || window.customElements.define("mega-menu-promo-carousel", MegaMenuPromoCarousel),
    window.customElements.get("navigation-drawer") || window.customElements.define("navigation-drawer", NavigationDrawer);
import { animate as m, scroll as p } from "//one2threejewelry.com/cdn/shop/t/46/assets/vendor.min.js?v=136053555471622566971792588923";
var FeatureChart = class extends HTMLElement {
    connectedCallback() {
        if (
            ((this.viewButtonElement = this.querySelector('[data-action="toggle-rows"]')),
            (this.featureChartTable = this.querySelector(".feature-chart__table")),
            (this.featureChartRows = Array.from(this.featureChartTable.childNodes)),
            (this.featureProductRow = this.querySelector(".feature-chart__table-row--product")),
            (this.featureChartSticky = this.querySelector(".feature-chart__table-row--sticky")),
            this.viewButtonElement && this.viewButtonElement.addEventListener("click", this._toggleRows.bind(this)),
            this.featureChartSticky)
        ) {
            (this.featureChartSticky.style.width = `${this.featureChartTable.scrollWidth}px`),
                this.featureChartTable.addEventListener("scroll", (e) => {
                    this.featureChartSticky.style.marginLeft = -1 * e.target.scrollLeft + "px";
                }),
                new ResizeObserver((e) => {
                    this.featureChartSticky.style.width = `${e[0].contentRect.width}px`;
                }).observe(this.featureChartTable);
            let e = getComputedStyle(this).scrollPaddingTop;
            p(
                ({ y: e }) => {
                    e.current >= e.targetOffset + this.featureProductRow.clientHeight / 2 && e.progress < 0.85 ? this.featureChartSticky.classList.add("is-visible") : this.featureChartSticky.classList.remove("is-visible");
                },
                { target: this.featureChartTable, offset: [`${e} start`, `end ${e}`] }
            );
        }
    }
    _toggleRows() {
        this.classList.contains("is-expanded") ? this._hideRows() : this._showRows();
    }
    async _showRows() {
        let e = this.featureChartTable.clientHeight;
        this.featureChartRows.forEach((e) => {
            e.hidden = !1;
        }),
            (this.viewButtonElement.querySelector(".feature-chart__toggle-text").innerText = this.viewButtonElement.getAttribute("data-view-less")),
            this.classList.add("is-expanded"),
            await m(this.featureChartTable, { height: [`${e}px`, `${this.featureChartTable.clientHeight}px`] }).finished,
            (this.featureChartTable.style.height = "auto");
    }
    async _hideRows() {
        let e = this.featureChartTable.clientHeight,
            t = 0;
        this.featureChartRows.slice(0, parseInt(this.getAttribute("max-rows"))).forEach((e) => {
            t += e.clientHeight;
        }),
            (this.viewButtonElement.querySelector(".feature-chart__toggle-text").innerText = this.viewButtonElement.getAttribute("data-view-more")),
            this.classList.remove("is-expanded"),
            await m(this.featureChartTable, { height: [`${e}px`, `${t}px`] }).finished,
            this.featureChartRows.slice(parseInt(this.getAttribute("max-rows"))).forEach((e) => (e.hidden = !0)),
            (this.featureChartTable.style.height = "auto");
    }
};
window.customElements.get("feature-chart") || window.customElements.define("feature-chart", FeatureChart);
import { scroll as g, timeline as f, animate as $, inView as y } from "//one2threejewelry.com/cdn/shop/t/46/assets/vendor.min.js?v=136053555471622566971792588923";
import { imageLoaded as v, getHeadingKeyframe as b } from "//one2threejewelry.com/cdn/shop/t/46/assets/theme.js?v=54322583012850650201792588923";
var ImageBanner = class extends HTMLElement {
    connectedCallback() {
        this.parallax && window.matchMedia("(prefers-reduced-motion: no-preference)").matches && this._setupParallax(),
            y(this, async () => {
                await v(Array.from(this.querySelectorAll(":scope > :is(img, video, iframe, svg, video-media)")));
                let e = Array.from(this.querySelectorAll('[reveal-on-scroll="true"]'));
                f([[this, { opacity: [0, 1] }, { duration: 0.25 }], ...e.map((e) => [...b(e)])]);
            });
    }
    get parallax() {
        return !!this.hasAttribute("parallax") && parseFloat(this.getAttribute("parallax"));
    }
    _setupParallax() {
        let e = Array.from(this.querySelectorAll(":scope > :is(img, video, iframe, svg, video-media)")),
            [t, i] = [1 + this.parallax, (100 * this.parallax) / (1 + this.parallax)];
        g($(e, { transform: [`scale(${t}) translateY(${i}%)`, `scale(${t}) translateY(0)`] }, { easing: "linear" }), { target: this, offset: ["start end", "end start"] });
    }
};
window.customElements.get("image-banner") || window.customElements.define("image-banner", ImageBanner);
import { ScrollArea as x } from "//one2threejewelry.com/cdn/shop/t/46/assets/theme.js?v=54322583012850650201792588923";
var ImageLinkBlocks = class extends HTMLElement {
    connectedCallback() {
        (this.items = Array.from(this.children)), new x(this), this.addEventListener("control:prev", this._prev), this.addEventListener("control:next", this._next);
    }
    _prev() {
        this.scrollBy({ left: ("rtl" === document.dir ? 1 : -1) * this.items[0].clientWidth, behavior: "smooth" });
    }
    _next() {
        this.scrollBy({ left: ("rtl" === document.dir ? -1 : 1) * this.items[0].clientWidth, behavior: "smooth" });
    }
};
window.customElements.get("image-link-blocks") || window.customElements.define("image-link-blocks", ImageLinkBlocks);
import { animate as w, timeline as _, inView as S } from "//one2threejewelry.com/cdn/shop/t/46/assets/vendor.min.js?v=136053555471622566971792588923";
import { getHeadingKeyframe as E, throttle as L } from "//one2threejewelry.com/cdn/shop/t/46/assets/theme.js?v=54322583012850650201792588923";
var ImagesWithTextScrolling = class extends HTMLElement {
    connectedCallback() {
        S(this, this._reveal.bind(this)),
            this.hasAttribute("scrolling-experience") &&
                ((this._imageToTransitionItems = Array.from(this.querySelectorAll(".images-scrolling-desktop__media-wrapper > :not(:first-child)"))),
                (this._mainImage = this.querySelector(".images-scrolling-desktop__media-wrapper > :first-child")),
                (this._contentItems = Array.from(this.querySelectorAll(".images-scrolling__content"))),
                this._imageToTransitionItems.length > 0 && window.addEventListener("scroll", L(this._onScroll.bind(this))));
    }
    _reveal() {
        Array.from(this.querySelectorAll('[reveal-on-scroll="true"]')).forEach((e) => {
            w(...E(e));
        });
    }
    _onScroll() {
        let e = this._mainImage.getBoundingClientRect(),
            t = e.bottom,
            i = this.getAttribute("scrolling-experience");
        for (let [s, r] of this._contentItems.entries()) {
            let a = r.getBoundingClientRect(),
                n = this._imageToTransitionItems[s - 1],
                o = this._contentItems[s];
            if (a.top < t - 0.15 * e.height && a.bottom > t) {
                n &&
                    !n.classList.contains("is-visible") &&
                    (n.classList.add("is-visible"),
                    "fade" === i
                        ? _([
                              [n, { opacity: [null, 1] }, { duration: 0.2 }],
                              [o, { opacity: [null, 1] }, { duration: 0.45, at: "<" }],
                          ])
                        : _([
                              [n, { opacity: [null, 1], clipPath: ["inset(100% 0 0 0)", "inset(0 0 0 0)"] }, { duration: 0.35, easing: [0.99, 0.01, 0.5, 0.94], opacity: { duration: 0 } }],
                              [o, { opacity: [null, 1] }, { duration: 0.45, at: "<" }],
                          ]));
                break;
            }
            if (a.top > t - 0.15 * e.height) {
                n &&
                    n.classList.contains("is-visible") &&
                    (n.classList.remove("is-visible"),
                    "fade" === i
                        ? _([
                              [n, { opacity: [null, 0] }, { duration: 0.2 }],
                              [o, { opacity: [null, 0] }, { duration: 0.2, at: "<" }],
                          ])
                        : _([
                              [n, { opacity: [null, 1], clipPath: ["inset(0 0 0 0)", "inset(100% 0 0 0)"] }, { duration: 0.35, easing: [0.99, 0.01, 0.5, 0.94], opacity: { duration: 0 } }],
                              [o, { opacity: [null, 0] }, { duration: 0.2, at: "<" }],
                          ]));
                break;
            }
        }
    }
};
window.customElements.get("images-with-text-scrolling") || window.customElements.define("images-with-text-scrolling", ImagesWithTextScrolling);
import { animate as A, inView as C } from "//one2threejewelry.com/cdn/shop/t/46/assets/vendor.min.js?v=136053555471622566971792588923";
var ImpactText = class extends HTMLElement {
    connectedCallback() {
        window.matchMedia("(prefers-reduced-motion: no-preference)").matches && C(this, ({ target: e }) => this._onBecameVisible(e), { margin: "-100px" });
    }
    async _onBecameVisible(e) {
        if ((A(e, { opacity: 1, transform: ["translateY(10px)", "translateY(0)"] }, { duration: 0.3 }), this.hasAttribute("count-up"))) {
            let t = 0 === this.childElementCount ? this : this.firstElementChild,
                i = t.textContent.trim().match(/\d+(?:[,. ]\d+)*/);
            if (!i) return;
            t.innerHTML = t.textContent.replace(/\d+(?:[,. ]\d+)*/, `<span>${i[0]}</span>`);
            let s = t.querySelector("span");
            (s.style.textAlign = i[0] === i.input ? null : "end"), t.classList.contains("text-gradient") || ((s.style.display = "inline-block"), (s.style.minWidth = `${s.clientWidth}px`));
            let r = i[0].replace(/[,\. ]+/, ""),
                a = [...i[0].matchAll(/[,\. ]+/g)];
            await A(
                (e) => {
                    let t = Math.round(e * parseInt(r)).toString();
                    a.forEach((e) => {
                        t.length >= i[0].length - e.index && (t = t.slice(0, e.index) + e[0] + t.slice(e.index));
                    }),
                        (s.textContent = 1 === e ? i[0] : t);
                },
                { duration: parseFloat(this.getAttribute("count-up")), easing: [0.16, 1, 0.3, 1] }
            ).finished,
                (s.style.minWidth = null);
        }
    }
};
window.customElements.get("impact-text") || window.customElements.define("impact-text", ImpactText);
import { timeline as k, inView as T } from "//one2threejewelry.com/cdn/shop/t/46/assets/vendor.min.js?v=136053555471622566971792588923";
var MediaGrid = class extends HTMLElement {
    connectedCallback() {
        (this.items = Array.from(this.children)), window.matchMedia("(prefers-reduced-motion: no-preference)").matches && T(this, this._onBecameVisible.bind(this));
    }
    _onBecameVisible() {
        let e = this.querySelectorAll(".content-over-media > :not(img, video, iframe, svg, video-media, native-video, external-video)");
        k([
            [this.items, { opacity: 1, transform: ["translateY(10px)", "translateY(0)"] }, { duration: 0.3 }],
            [e, { opacity: [0, 1] }, { duration: 0.2, at: "+0.1" }],
        ]);
    }
};
window.customElements.get("media-grid") || window.customElements.define("media-grid", MediaGrid);
import { animate as q, timeline as I, inView as P } from "//one2threejewelry.com/cdn/shop/t/46/assets/vendor.min.js?v=136053555471622566971792588923";
import { imageLoaded as M } from "//one2threejewelry.com/cdn/shop/t/46/assets/theme.js?v=54322583012850650201792588923";
var reduceMotion = window.matchMedia("(prefers-reduced-motion: no-preference)").matches,
    MediaWithText = class extends HTMLElement {
        connectedCallback() {
            reduceMotion &&
                Array.from(this.querySelectorAll(".media-with-text__item")).forEach((e) => {
                    P(e, (e) => this.reveal(e.target));
                });
        }
        reveal(e) {
            let t = e.querySelector(".media-with-text__media");
            M(t.querySelector("img")).then(() => {
                I([
                    [t, { opacity: [0, 1] }, { duration: 0.3 }],
                    [t.querySelector("img, video-media"), { transform: ["scale(1.05)", "scale(1)"] }, { duration: 0.3, at: "<" }],
                ]);
            }),
                q(e.querySelector(".media-with-text__content > .prose"), { opacity: [0, 1] }, { duration: 0.2, delay: 0.3 });
        }
    };
window.customElements.get("media-with-text") || window.customElements.define("media-with-text", MediaWithText);
import { timeline as Y, animate as D, stagger as X, inView as O } from "//one2threejewelry.com/cdn/shop/t/46/assets/vendor.min.js?v=136053555471622566971792588923";
import { EffectCarousel as j, imageLoaded as V, getHeadingKeyframe as B } from "//one2threejewelry.com/cdn/shop/t/46/assets/theme.js?v=54322583012850650201792588923";
var MultipleImagesWithText = class extends HTMLElement {
        constructor() {
            super(),
                (this._imageCarousel = this.querySelector("multiple-images-with-text-image-list")),
                (this._contentCarousel = this.querySelector("multiple-images-with-text-content-list")),
                this.addEventListener("control:prev", () => {
                    this._imageCarousel.previous(), this._contentCarousel.previous();
                }),
                this.addEventListener("control:next", () => {
                    this._imageCarousel.next(), this._contentCarousel.next();
                }),
                Shopify.designMode &&
                    this.addEventListener("shopify:block:select", (e) => {
                        e.target.hasAttribute("image-id") && this._imageCarousel.select(this._imageCarousel.items.findIndex((t) => t.id === e.target.getAttribute("image-id")));
                    });
        }
    },
    MultipleImagesWithTextImageList = class extends j {
        constructor() {
            super(), O(this, this._reveal.bind(this));
        }
        async _reveal() {
            await V(this.querySelectorAll("img")),
                "stacked" === this.getAttribute("layout")
                    ? Y(
                          [
                              [this.lastElementChild, { transform: "rotate(0deg)" }],
                              [this.lastElementChild?.previousElementSibling, { transform: "rotate(2deg)" }, { at: "<" }],
                              [this.lastElementChild?.previousElementSibling?.previousElementSibling, { transform: "rotate(-2deg)" }, { at: "<" }],
                          ],
                          { defaultOptions: { duration: 0.15, easing: [0.26, 0.02, 0.27, 0.97] } }
                      )
                    : "collage" === this.getAttribute("layout")
                    ? Y([[this.children, { opacity: 1, transform: ["translateY(15px)", "translateY(0)"] }, { duration: 0.3, delay: X(0.1) }]])
                    : Y([[this.children, { opacity: 1, transform: "rotate(var(--image-rotation, 0deg))" }, { duration: 0.3, delay: X(0.1) }]]);
        }
        _transitionTo(e, t, { direction: i, animate: s }) {
            if ("stacked" === this.getAttribute("layout")) {
                if ("next" === i) {
                    let r = getComputedStyle(e).getPropertyValue("transform");
                    return Y(
                        [
                            [e, { opacity: 0, transform: "rotate(5deg) translate(40px, 10px)" }, { duration: 0.2 }],
                            [t, { zIndex: 1 }, { duration: 0.2, zIndex: { easing: "step-start" } }],
                            [e, { opacity: 1, transform: r, zIndex: -1 }, { duration: 0.2, at: "<", zIndex: { easing: "step-start" } }],
                            [t.previousElementSibling, { zIndex: 0 }, { at: "<", easing: "step-start" }],
                        ],
                        { defaultOptions: { easing: [0.26, 0.02, 0.27, 0.97] } }
                    ).finished;
                }
                {
                    let a = getComputedStyle(t).getPropertyValue("transform");
                    return Y(
                        [
                            [t, { opacity: 0, transform: "rotate(-5deg) translate(-40px, -10px)" }, { duration: 0.2 }],
                            this.items.length >= 3 && [e.previousElementSibling || this.lastElementChild, { zIndex: -1 }, { easing: "step-start" }],
                            [t, { opacity: 1, transform: a, zIndex: 1 }, { duration: 0.2, at: this.items.length >= 3 ? "<" : "+0", zIndex: { easing: "step-start" } }],
                            [e, { zIndex: 0 }, { duration: 0.2, at: "<", zIndex: { easing: "step-start" } }],
                        ].filter(Boolean),
                        { defaultOptions: { easing: [0.26, 0.02, 0.27, 0.97] } }
                    ).finished;
                }
            }
        }
    },
    MultipleImagesWithTextContentList = class extends j {
        constructor() {
            super(), O(this, this._reveal.bind(this));
        }
        _reveal() {
            D(...B(this.querySelector('[reveal-on-scroll="true"]')));
        }
        _transitionTo(e, t, { direction: i = "next", animate: s = !0 } = {}) {
            return (
                e.classList.remove("is-selected"),
                t.classList.add("is-selected"),
                Y([[e, { opacity: [1, 0], visibility: ["visible", "hidden"] }], [t, { opacity: [0, 1], visibility: ["hidden", "visible"] }], [...B(t.querySelector('[reveal-on-scroll="true"]'), { at: "<" })]], {
                    duration: s ? parseFloat(this.getAttribute("fade-speed") || 0.5) : 0,
                }).finished
            );
        }
    };
window.customElements.get("multiple-images-with-text") || window.customElements.define("multiple-images-with-text", MultipleImagesWithText),
    window.customElements.get("multiple-images-with-text-image-list") || window.customElements.define("multiple-images-with-text-image-list", MultipleImagesWithTextImageList),
    window.customElements.get("multiple-images-with-text-content-list") || window.customElements.define("multiple-images-with-text-content-list", MultipleImagesWithTextContentList);
import { Drawer as R } from "//one2threejewelry.com/cdn/shop/t/46/assets/theme.js?v=54322583012850650201792588923";
var NewsletterPopup = class extends R {
    connectedCallback() {
        super.connectedCallback(), this.shouldAppearAutomatically && setTimeout(() => this.show(), this.apparitionDelay);
    }
    get initialFocus() {
        return !1;
    }
    get shouldAppendToBody() {
        return !1;
    }
    get apparitionDelay() {
        return 1e3 * parseInt(this.getAttribute("apparition-delay") || 0);
    }
    get shouldAppearAutomatically() {
        return !("true" === localStorage.getItem("theme:popup-filled") || (this.hasAttribute("only-once") && "true" === localStorage.getItem("theme:popup-appeared")));
    }
    _setInitialPosition() {
        (this.style.top = null), (this.style.bottom = "0px"), (this.style.left = "ltr" === document.dir ? null : "0px"), (this.style.right = "rtl" === document.dir ? "auto" : "0px");
    }
    attributeChangedCallback(e, t, i) {
        super.attributeChangedCallback(e, t, i), "open" === e && this.open && localStorage.setItem("theme:popup-appeared", "true");
    }
};
window.customElements.get("newsletter-popup") || window.customElements.define("newsletter-popup", NewsletterPopup);
import { timeline as z, animate as F, inView as H } from "//one2threejewelry.com/cdn/shop/t/46/assets/vendor.min.js?v=136053555471622566971792588923";
import { EffectCarousel as W } from "//one2threejewelry.com/cdn/shop/t/46/assets/theme.js?v=54322583012850650201792588923";
var reduceMotion2 = window.matchMedia("(prefers-reduced-motion: no-preference)").matches,
    PressCarousel = class extends W {
        constructor() {
            super(), reduceMotion2 && H(this, this._reveal.bind(this));
        }
        _reveal() {
            F(this.selectedSlide.querySelector(".blockquote"), { opacity: 1, transform: ["translateY(15px)", "translateY(0)"] }, { duration: 0.2 });
        }
        async _transitionTo(e, t, i = {}) {
            await z([
                [e.querySelectorAll(".press__logo, .press__author"), { opacity: [null, 0] }, { duration: 0.2 }],
                [e.querySelector(".blockquote"), { opacity: [null, 0], ...(reduceMotion2 && { transform: [null, "translateY(-10px)"] }) }, { duration: 0.2, at: "<" }],
            ]).finished,
                e.classList.remove("is-selected"),
                t.classList.add("is-selected"),
                await z([
                    [t.querySelectorAll(".press__logo, .press__author"), { opacity: [0, 1] }, { duration: 0.2 }],
                    [t.querySelector(".blockquote"), { opacity: [0, 1], ...(reduceMotion2 && { transform: ["translateY(10px)", "translateY(0px)"] }) }, { duration: 0.2, at: "<" }],
                ]).finished;
        }
    };
window.customElements.get("press-carousel") || window.customElements.define("press-carousel", PressCarousel);
var ProductRecommendations = class extends HTMLElement {
    constructor() {
        super(), (this._isLoaded = !1);
    }
    connectedCallback() {
        this._loadRecommendations();
    }
    async _loadRecommendations() {
        if (this._isLoaded) return;
        this._isLoaded = !0;
        let e = this.closest(".shopify-section"),
            t = this.getAttribute("intent") || "related",
            i = `${Shopify.routes.root}recommendations/products?product_id=${this.getAttribute("product")}&limit=${this.getAttribute("limit") || 4}&section_id=${e.id.replace("shopify-section-", "")}&intent=${t}`,
            s = await fetch(i, { priority: "low" }),
            r = new DOMParser().parseFromString(await s.text(), "text/html"),
            a = r.querySelector("product-recommendations");
        a.childElementCount > 0 ? this.replaceChildren(...document.importNode(a, !0).childNodes) : "related" === t ? e.remove() : this.remove();
    }
};
window.customElements.get("product-recommendations") || window.customElements.define("product-recommendations", ProductRecommendations);
import { extractSectionId as N } from "//one2threejewelry.com/cdn/shop/t/46/assets/theme.js?v=54322583012850650201792588923";
var RecentlyViewedProducts = class extends HTMLElement {
    constructor() {
        super(...arguments), __privateAdd(this, _searchQueryString), __privateAdd(this, _loadProducts), __privateAdd(this, _isLoaded, !1);
    }
    connectedCallback() {
        "requestIdleCallback" in window ? requestIdleCallback(__privateMethod(this, _loadProducts, loadProducts_fn).bind(this), { timeout: 1500 }) : __privateMethod(this, _loadProducts, loadProducts_fn).call(this);
    }
};
(_isLoaded = new WeakMap()),
    (_searchQueryString = new WeakSet()),
    (searchQueryString_get = function () {
        let e = new Set(JSON.parse(localStorage.getItem("theme:recently-viewed-products") || "[]"));
        return (
            this.hasAttribute("exclude-id") && e.delete(parseInt(this.getAttribute("exclude-id"))),
            Array.from(e.values(), (e) => `id:${e}`)
                .slice(0, parseInt(this.getAttribute("products-count")))
                .join(" OR ")
        );
    }),
    (_loadProducts = new WeakSet()),
    (loadProducts_fn = async function () {
        if (__privateGet(this, _isLoaded)) return;
        __privateSet(this, _isLoaded, !0);
        let e = this.closest(".shopify-section"),
            t = `${Shopify.routes.root}search?type=product&q=${__privateGet(this, _searchQueryString, searchQueryString_get)}&section_id=${N(e)}`,
            i = await fetch(t, { priority: "low" }),
            s = new DOMParser().parseFromString(await i.text(), "text/html"),
            r = s.querySelector("recently-viewed-products");
        r.childElementCount > 0 ? this.replaceChildren(...document.importNode(r, !0).childNodes) : e.remove();
    }),
    window.customElements.get("recently-viewed-products") || window.customElements.define("recently-viewed-products", RecentlyViewedProducts);
import { scroll as K, timeline as Q, ScrollOffset as G, inView as U } from "//one2threejewelry.com/cdn/shop/t/46/assets/vendor.min.js?v=136053555471622566971792588923";
var RevealedImage = class extends HTMLElement {
    connectedCallback() {
        let e = this.querySelector(".revealed-image__scroll-tracker"),
            t = this.querySelector(".revealed-image__scroller");
        (e.style.height = `${t.clientHeight}px`),
            new ResizeObserver((t) => (e.style.height = `${t[0].contentRect.height}px`)).observe(t),
            K(
                Q([
                    [this.querySelectorAll(".revealed-image__image-clipper, .revealed-image__content--inside"), { clipPath: ["inset(37% 37% 41% 37%)", "inset(calc(var(--sticky-area-height) / 2) 0)"] }, { easing: "ease-in" }],
                    [this.querySelectorAll("img, svg"), { transform: ["translate(-10%, -1.5%) scale(1.4)", "translate(0, 0) scale(1)"] }, { easing: "ease-in", at: "<" }],
                    [this.querySelectorAll(".revealed-image__content"), { opacity: [0, 1, 1] }, { offset: [0, 0.25, 1], at: "<" }],
                ]),
                { target: e, offset: G.All }
            ),
            U(
                this,
                () => (
                    (this.style.visibility = "visible"),
                    () => {
                        this.style.visibility = "hidden";
                    }
                ),
                { margin: "200px" }
            );
    }
};
window.customElements.get("revealed-image") || window.customElements.define("revealed-image", RevealedImage);
var ShopTheLookDots = class extends HTMLElement {
    connectedCallback() {
        (this._abortController = new AbortController()),
            Array.from(this.children).forEach((e) => {
                document.getElementById(e.getAttribute("aria-controls")).addEventListener("carousel:change", (e) => this._onDotClicked(e), { signal: this._abortController.signal });
            });
    }
    disconnectedCallback() {
        this._abortController.abort();
    }
    _onDotClicked(e) {
        Array.from(this.querySelectorAll(`button:nth-child(${e.detail.index + 1})`)).forEach((e) => e.click());
    }
};
window.customElements.get("shop-the-look-dots") || window.customElements.define("shop-the-look-dots", ShopTheLookDots);
import { animate as J, timeline as Z, inView as ee } from "//one2threejewelry.com/cdn/shop/t/46/assets/vendor.min.js?v=136053555471622566971792588923";
import { EffectCarousel as et, imageLoaded as ei, getHeadingKeyframe as es } from "//one2threejewelry.com/cdn/shop/t/46/assets/theme.js?v=54322583012850650201792588923";
var Slideshow = class extends HTMLElement {
        constructor() {
            super(), this.addEventListener("carousel:select", this._onSlideSelected);
        }
        async _onSlideSelected(e) {
            let t = getComputedStyle(e.detail.slide);
            this.style.setProperty("--slideshow-controls-background", t.getPropertyValue("--slideshow-slide-controls-background"));
            this.style.setProperty("--slideshow-controls-color", t.getPropertyValue("--slideshow-slide-controls-color"));
            
            if (!this.classList.contains("slideshow--boxed")) return;
            
            let i = this.querySelector(".slideshow__slide-background");
            let s = t.getPropertyValue("--slideshow-slide-background");
            i.style.background = s;
            i.style.opacity = "1";
            this.style.setProperty("--slideshow-background", s);
        }
    },
    SlideshowCarousel = class extends et {
        constructor() {
            super(), ee(this, this._reveal.bind(this)), this.querySelector(".slideshow__cursor") && this.addEventListener("tap", this._onSlideshowTap);
        }
        connectedCallback() {
            super.connectedCallback();
            this.style.opacity = "1";
        }
        _reveal() {
            this.style.opacity = "1";
        }
        _transitionTo(e, t, {direction: i, animate: s = !0} = {}) {
            e.classList.remove("is-selected");
            e.style.opacity = "0";
            e.style.visibility = "hidden";
            
            t.classList.add("is-selected");
            t.style.opacity = "1";
            t.style.visibility = "visible";
            
            return Promise.resolve();
        }
        _fade(e, t) {
            e.style.opacity = "0";
            e.style.visibility = "hidden";
            e.style.zIndex = "0";
            
            t.style.opacity = "1";
            t.style.visibility = "visible";
            t.style.zIndex = "1";
            
            return Promise.resolve();
        }
        _fadeWithText(e, t) {
            e.style.opacity = "0";
            e.style.visibility = "hidden";
            e.style.zIndex = "0";
            
            t.style.opacity = "1";
            t.style.visibility = "visible";
            t.style.zIndex = "1";
            
            t.querySelectorAll("img, [data-sequence='subheading'], .button, [data-sequence='heading']").forEach(el => {
                el.style.opacity = "1";
                el.style.transform = "none";
            });
            
            return Promise.resolve();
        }
        _onSlideshowTap(e) {
            if (!e.target.matches("button, a[href], button :scope, a[href] :scope") && window.matchMedia("screen and (pointer: fine)").matches) {
                e.detail.originalEvent.clientX > window.innerWidth / 2 ? this.next() : this.previous();
            }
        }
    };
window.customElements.get("x-slideshow") || window.customElements.define("x-slideshow", Slideshow), window.customElements.get("slideshow-carousel") || window.customElements.define("slideshow-carousel", SlideshowCarousel);
